/**
 * Container component for a menu row button
 *
 * Passes all props through to RowButtonView.
 * @module components/RowButton/RowButtonContainer
 */

import { PressableProps } from "react-native";

import RowButtonView from "./RowButtonView";

/** Semantic border tone for a row's top divider */
type RowButtonBorderTone = "default" | "subtle" | "strong";

/**
 * Props for RowButtonContainer component
 */
interface RowButtonContainerProps extends PressableProps {
  label: string;
  description?: string;
  leftIcon?: React.ElementType;
  rightIcon?: React.ElementType;
  isDark?: boolean;
  /** Renders a top divider; tone selects the semantic outline token */
  topBorderTone?: RowButtonBorderTone;
  /** Indents the row content (nested sub-rows) */
  indented?: boolean;
  /** Renders the label in the error tone (destructive action) */
  destructive?: boolean;
}

/**
 * Container for a menu row button — delegates rendering to RowButtonView
 * @param props - Component props forwarded to the view
 * @returns Rendered RowButton component
 */
const RowButtonContainer = (props: RowButtonContainerProps) => (
  <RowButtonView {...props} />
);

RowButtonContainer.displayName = "RowButtonContainer";

export default RowButtonContainer;
